module.exports = __webpack_public_path__ + "static/media/Electronic-Tom-1.f34eaf34.wav";